import { useQuery } from "@tanstack/react-query";

import { createAppsFilterDescriptionQuery } from "./options";

type Options = {
    readonly enabled?: boolean;
};

export default function useAppsFilterDescriptionQuery({ enabled }: Options = {}) {
    return useQuery(createAppsFilterDescriptionQuery({ enabled }));
}
